import React, { memo } from 'react';
import CustomImage from "components/CustomImage/CustomImage";
import moment from "moment";
import { energyData, statusData } from "variables/lists/meters";
import { metertext } from "variables/meters";
import { serverTypeLorawanGateway } from "variables/MBM/lists/avobbox";
import { PropaneSharp } from '@mui/icons-material';

const numFmt = new Intl.NumberFormat();

export const InfoWindowContent = memo(({ features, setActiveSiteId }) => {
    if (features.length === 1) {
        const f = features[0];
        const props = f.properties;

        return (
            <>
                <div style={{ marginBottom: '10px' }}>
                    <div class='bacsinfotext'>{"Nom : " + (f.properties.otherparameters?.name || '')}</div>
                    <div class='bacsinfotext'>{"Type : " + ((energyData.find((d) => d.id === f.properties.energy)?.name) || '')}</div>
                    <div class='bacsinfotext'>{"Description : " + (f.properties.otherparameters?.description || '')}</div>
                    <div class='bacsinfotext'>{"Statut : " + (f.properties.otherparameters?.status ? statusData.find((s) => s.id === f.properties.otherparameters?.status)?.name : '')}</div>
                </div>
                <div style={{ marginBottom: '10px' }}>
                    <div class='infowindowcontentmeteraction' onClick={() => setActiveSiteId(f.id)}>Voir les détails du compteur</div>
                </div>
            </>
        );
    }

    return (
        <div style={{ marginBottom: '10px' }}>
            <div class='bacsinfotext'>{numFmt.format(features.length) + ' compteurs : '}</div>
            {features.slice(0, 5).map(feature => {
                const props = feature.properties;

                return (
                    <div class='infowindowcontentmeteraction' onClick={() => setActiveSiteId(feature.id)}>
                        {props.name}  {" ("} {(energyData.find((f) => f.id === props.energy)?.name)} {")"}</div>
                );
            })}

            {features.length > 5 && (
                <div class='bacsinfotextgateways'>...</div>
            )}
            {
                features.find((f) => f.properties.energy === 'electricity') ?
                    <div class='bacsinfotext'>{(energyData.find((f) => f.id === 'electricity').name) + " : " + (features.filter((f) => f.properties.energy === 'electricity').length) + " " + metertext.meters}</div> : <></>
            }
            {
                features.find((f) => f.properties.energy === 'gas') ?
                    <div class='bacsinfotext'>{(energyData.find((f) => f.id === 'gas').name) + " : " + (features.filter((f) => f.properties.energy === 'gas').length) + " " + metertext.meters}</div> : <></>
            }
            {
                features.find((f) => f.properties.energy === 'water') ?
                    <div class='bacsinfotext'>{(energyData.find((f) => f.id === 'water').name) + " : " + (features.filter((f) => f.properties.energy === 'water').length) + " " + metertext.meters}</div> : <></>
            }
            {
                features.find((f) => f.properties.energy === 'heat') ?
                    <div class='bacsinfotext'>{(energyData.find((f) => f.id === 'heat').name) + " : " + (features.filter((f) => f.properties.energy === 'heat').length) + " " + metertext.meters}</div> : <></>
            }
            {
                features.find((f) => f.properties.energy === 'cold') ?
                    <div class='bacsinfotext'>{(energyData.find((f) => f.id === 'cold').name) + " : " + (features.filter((f) => f.properties.energy === 'cold').length) + " " + metertext.meters}</div> : <></>
            }
            {
                features.find((f) => f.properties.energy === 'propane') ?
                    <div class='bacsinfotext'>{(energyData.find((f) => f.id === 'propane').name) + " : " + (features.filter((f) => f.properties.energy === 'propane').length) + " " + metertext.meters}</div> : <></>
            }
            {
                features.find((f) => f.properties.energy === 'fuel') ?
                    <div class='bacsinfotext'>{(energyData.find((f) => f.id === 'fuel').name) + " : " + (features.filter((f) => f.properties.energy === 'fuel').length) + " " + metertext.meters}</div> : <></>
            }
            {
                features.find((f) => f.properties.energy === 'wood') ?
                    <div class='bacsinfotext'>{(energyData.find((f) => f.id === 'wood').name) + " : " + (features.filter((f) => f.properties.energy === 'wood').length) + " " + metertext.meters}</div> : <></>
            }
        </div>
    );
});

